import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgReferralIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx={19} cy={5} r={2} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={9} cy={12} r={6} stroke="currentColor" strokeWidth={1.5} />
    <circle
      r={1.5}
      transform="matrix(-1 0 0 1 9 9.5)"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <ellipse
      rx={3}
      ry={2.5}
      transform="matrix(-1 0 0 1 9 15.5)"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <circle cx={19} cy={19} r={2} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="m13.5 8 4-2M13.5 16l3.5 2"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgReferralIcon);
const Memo = memo(ForwardRef);
export default Memo;
